export function getTranslation(lang: string): {
    learnMore: string;
    apr: string;
    apy: string;
    asLowAs: string;
} {
    const translationStrings = {
        en: {
            learnMore: 'Learn More',
            apr: 'APR',
            apy: 'APY',
            asLowAs: 'as low as',
        },
        es: {
            learnMore: 'Aprenda Más',
            apr: 'TAE',
            apy: 'RPA',
            asLowAs: 'tan bajo como',
        }
    }
    return translationStrings[lang];
}
